import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getUserAccNoAndZipcode } from '../../../../shared/hooks/useFetchLogin';
import API_URLS from "../../Utils/axr";
import store from '../store';
import { setHeaders } from './brightspeedToken';


// Async thunk for fetching user account data
export const fetchUserAccountData = createAsyncThunk(
  'userAccount/fetchUserAccountData',
  async ({ body, headers }: { body: any; headers: any }, thunkAPI) => {
    try {
      const response = await getUserAccNoAndZipcode(
        { '': API_URLS?.paymetArrangemetUserValidateURL },
        body,
        headers
      );
      if (response?.data?.siteId) {
        localStorage.setItem("headersSiteId", response.data.siteId.toLowerCase());
        store.dispatch(
                  setHeaders({
                    ...headers,
                    siteId: response?.data?.siteId?.toLowerCase(), // || "ctl",
                    networkType:response?.data?.networkType,
                    billingSystem: response?.data?.billingSystem,
                    billingType:response?.data?.billingType
                  })
                );
      }
      return response; // Return the full response
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Failed to fetch');
    }
  }
);

interface UserAccountState {
  billingSystem: string;
  networkType: string;
  siteId: string;
  accountApiResponse: any | null; // Holds full API response related to user account
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  isPostPaidFiberFlag: boolean;
  accountId: string;
  addressId: string;
}

const initialState: UserAccountState = {
  billingSystem: '',
  networkType: '',
  siteId: '',
  accountApiResponse: null,
  status: 'idle',
  error: null,
  isPostPaidFiberFlag: false,
  accountId: '',
  addressId: ''
};

const userAccountSlice = createSlice({
  name: 'userAccount',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAccountData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUserAccountData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.accountApiResponse = action.payload;
        const data = action.payload?.data || {};

        state.billingSystem = data?.billingSystem || '';
        state.networkType = data?.networkType || '';
        state.siteId = (data?.siteId || '').toLowerCase();
        state.isPostPaidFiberFlag = (data?.billingSystem?.toUpperCase() ==="BRIM" && data?.siteId?.toLowerCase() !== "ctl" && data?.billingType?.toLowerCase() === "postpaid")? true : false;
        state.accountId = data?.billingAccountNumber;
        state.addressId = data?.addressId;
      })
      .addCase(fetchUserAccountData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string || action.error.message || 'Failed to fetch user account data';
      });
  },
});

export default userAccountSlice.reducer;
